import { FC } from 'react'

import { NodeViewProps } from '@tiptap/react'
import ReactPlayer from 'react-player'

import { SupportedAudioFormats } from '../../config/constants'
import { Container } from '../Container'

export const Video: FC<NodeViewProps> = props => {
  const { src, type } = props.node.attrs
  const isAudio = SupportedAudioFormats.includes(type)

  return (
    <Container {...props}>
      <ReactPlayer
        url={src}
        controls
        width="100%"
        height={isAudio ? '50px' : '100%'}
        config={{
          file: { forceAudio: isAudio },
        }}
      />
    </Container>
  )
}
